import Translate, { translate as translateFn } from "./Translate";
import { connect } from "react-redux";

const mapStateToProps = (state, ownProps) => {
    return {
        translations: state.locale.translations,
        props: ownProps
    };
};

const T = connect(mapStateToProps)(Translate);

export const translate = translateFn;

export default T;



// WEBPACK FOOTER //
// ./src/components/Common/TranslateContainer/TranslateContainer.js